// AI-CONTEXT: See docs/features/updates-log.md
// De tabbladen boven de Updates-lijst: één per categorie die daadwerkelijk
// updates heeft, met 'Alles' ervoor.

import { ALWAYS_VISIBLE_MODULE, UPDATE_MODULES, UPDATE_MODULE_SLUGS } from './updateModules'

/**
 * @typedef {object} UpdateTab
 * @property {string} slug - 'alles' of een modulecode
 * @property {string} label - Wat op het tabblad staat
 * @property {number} count - Aantal updates onder dit tabblad
 */

const ALLES = 'alles'

/**
 * Bouwt de tabbladen voor een al gefilterde lijst updates.
 *
 * Een categorie zonder updates krijgt geen tabblad — een leeg tabblad is een
 * doodlopend pad. De volgorde is die van UPDATE_MODULE_SLUGS, zodat de tabs
 * niet verspringen als er een categorie bijkomt of wegvalt.
 *
 * `activeModules` is nodig omdat een update bij twéé categorieën kan horen.
 * filterUpdates laat zo'n update door zodra ÉÉN daarvan aanstaat, en zonder
 * die opgave maakte deze helper vervolgens ook een tabblad voor de andere —
 * de beheeromgeving kreeg zo een FIXtool-tabblad terwijl die module uitstaat.
 * Zonder opgave blijft alleen 'algemeen' over: de poort valt dicht, net als in
 * filterUpdates.
 * AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
 *
 * @param {Array<object>} updates - Updates die deze organisatie mag zien
 * @param {Array<string>} [activeModules] - Modulecodes die de organisatie afneemt
 * @returns {Array<UpdateTab>} Tabbladen, 'Alles' voorop; leeg als er niets is
 */
const buildUpdateTabs = (updates, activeModules) => {
    if (!Array.isArray(updates) || updates.length === 0) return []

    const zichtbaar = new Set([ALWAYS_VISIBLE_MODULE])
    if (Array.isArray(activeModules)) {
        activeModules
            .filter((slug) => UPDATE_MODULE_SLUGS.includes(slug))
            .forEach((slug) => zichtbaar.add(slug))
    }

    const tabs = [{ slug: ALLES, label: 'Alles', count: updates.length }]

    UPDATE_MODULE_SLUGS.forEach((slug) => {
        if (!zichtbaar.has(slug)) return

        // Een update met twee zichtbare categorieën telt bij beide mee — hij
        // hoort ook echt onder allebei de tabbladen thuis.
        const count = updates.filter((update) => update.modules.includes(slug)).length
        if (count === 0) return
        tabs.push({ slug, label: UPDATE_MODULES[slug].label, count })
    })

    return tabs
}

export { ALLES }
export default buildUpdateTabs
